
<template>

	<mymodal ref="modal" title="Настройки модели" ok="Сохранить" :reset="reset" :check="check" :submit="submit">

		<h4 class="mb-2">Обучающая выборка</h4>

			<b-form-group label="Средняя ошибка" label-cols="6">

				<b-form-input type="number" v-model="in_data.conf.average_error.teach" min="0" max="100" v-on:input="check"
					title="Введите от 0% до 100%"
					:state="average_error_teach_state"
					invalid-feedback="Введите от 0% до 100%"
				/>

			</b-form-group>

			<b-form-group label="Среднеквадратичная ошибка" label-cols="6">

				<b-form-input type="number" v-model="in_data.conf.square_error.teach" min="0" max="100" v-on:input="check"
					title="Введите от 0% до 100%"
					:state="square_error_teach_state"
					invalid_feedback="Введите от 0% до 100%"
				/>

			</b-form-group>

			<b-form-group label="Коэффициент детерминации" label-cols="6">

				<b-form-input type="number" v-model="in_data.conf.determination_coef.teach" v-on:input="check"
					title="Введите от 0 до 1"
					:state="determination_coef_teach_state"
					invalid_feedback="Введите от 0 до 1"
				/>

			</b-form-group>

		<h4 class="mb-2">Контрольная выборка</h4>

			<b-form-group label="Средняя ошибка" label-cols="6">

				<b-form-input type="number" v-model="in_data.conf.average_error.test" min="0" max="100" v-on:input="check"
					title="Введите от 0% до 100%"
					:state="average_error_test_state"
					invalid-feedback="Введите от 0% до 100%"
				/>

			</b-form-group>

			<b-form-group label="Среднеквадратичная ошибка" label-cols="6">

				<b-form-input type="number" v-model="in_data.conf.square_error.test" min="0" max="100" v-on:input="check"
					title="Введите от 0% до 100%"
					:state="square_error_test_state"
					invalid_feedback="Введите от 0% до 100%"
				/>

			</b-form-group>

			<b-form-group label="Коэффициент детерминации" label-cols="6">

				<b-form-input type="number" v-model="in_data.conf.determination_coef.test" v-on:input="check"
					title="Введите от 0 до 1"
					:state="determination_coef_test_state"
					invalid_feedback="Введите от 0 до 1"
				/>

			</b-form-group>
		
			<div>
				<div class="d-flex justify-content-between" style="align-items: center;">
					<label for="range-1">Обучающая выборка: 
						<b-form-input type="number" v-model="teach_set_size_percentage"
							title="Введите от 0% до 100%"
							size="sm" style="display: inline;width: 60px;"
							min="0" max="100"
						></b-form-input> %
					</label>
					<label for="range-1">Контрольная выборка: {{ 100 - teach_set_size_percentage }}%</label>
				</div>
				<b-form-input id="range-1" v-model="teach_set_size_percentage" type="range" min="0" max="100" step="5"></b-form-input>
			</div>


	</mymodal>

</template>

<script>

import mymodal from "../../../../widgets/modal"

export default
{
	props :
	{
		cost_evaluation_id : String,
		data : Object,
	},

	components :
	{
		mymodal,
	},

	watch :
	{
		data :
		{
			immediate : true,
			handler(data)
			{
				if(data)
				{
					this.in_data =
					{
						conf :
						{
							square_error :
							{
								teach : data.conf.square_error.teach * 100,
								test : data.conf.square_error.test * 100,
							},
							determination_coef :
							{
								teach : data.conf.determination_coef.teach,
								test : data.conf.determination_coef.test,
							},
							average_error :
							{
								teach : data.conf.average_error.teach * 100,
								test : data.conf.average_error.test * 100,
							},
						}
					}
					this.teach_set_size_percentage = data.conf.teach_set_size_percentage
				}
			}
		},
	},

	data()
	{
		return {

			in_data : { conf : { square_error : {}, average_error : {}, determination_coef : {} } },
			teach_set_size_percentage : 65,

			average_error_teach_state : null,
			square_error_teach_state : null,
			determination_coef_teach_state : null,
			average_error_test_state : null,
			square_error_test_state : null,
			determination_coef_test_state : null,

		}
	},

	methods :
	{
		check()
		{
			this.average_error_teach_state = !! this.in_data.conf.average_error.teach && Number(this.in_data.conf.average_error.teach) >= 0 && Number(this.in_data.conf.average_error.teach) <= 100
			this.square_error_teach_state = !! this.in_data.conf.square_error.teach && Number(this.in_data.conf.square_error.teach) >= 0 && Number(this.in_data.conf.square_error.teach) <= 100
			this.determination_coef_teach_state = !! this.in_data.conf.determination_coef.teach && Number(this.in_data.conf.determination_coef.teach) >= 0 && Number(this.in_data.conf.determination_coef.teach) <= 1
			this.average_error_test_state = !! this.in_data.conf.average_error.test && Number(this.in_data.conf.average_error.test) >= 0 && Number(this.in_data.conf.average_error.test) <= 100
			this.square_error_test_state = !! this.in_data.conf.square_error.test && Number(this.in_data.conf.square_error.test) >= 0 && Number(this.in_data.conf.square_error.test) <= 100
			this.determination_coef_test_state = !! this.in_data.conf.determination_coef.test && Number(this.in_data.conf.determination_coef.test) >= 0 && Number(this.in_data.conf.determination_coef.test) <= 1

			return this.average_error_teach_state && this.square_error_teach_state && this.determination_coef_teach_state && this.average_error_test_state && this.square_error_test_state && this.determination_coef_test_state
		},

		reset()
		{
			this.average_error_teach_state = null
			this.square_error_teach_state = null
			this.determination_coef_teach_state = null
			this.average_error_test_state = null
			this.square_error_test_state = null
			this.determination_coef_test_state = null
		},

		execute()
		{
			this.$refs.modal.execute()
		},

		submit()
		{
			var fields =
			{
				"modeling.conf.average_error.teach" : Number(this.in_data.conf.average_error.teach) / 100,
				"modeling.conf.square_error.teach" : Number(this.in_data.conf.square_error.teach) / 100,
				"modeling.conf.determination_coef.teach" : Number(this.in_data.conf.determination_coef.teach),
				"modeling.conf.average_error.test" : Number(this.in_data.conf.average_error.test) / 100,
				"modeling.conf.square_error.test" : Number(this.in_data.conf.square_error.test) / 100,
				"modeling.conf.determination_coef.test" : Number(this.in_data.conf.determination_coef.test),
				"modeling.conf.teach_set_size_percentage" : Number(this.teach_set_size_percentage),
			}

			this.data.conf.average_error.teach = Number(this.in_data.conf.average_error.teach) / 100
			this.data.conf.square_error.teach = Number(this.in_data.conf.square_error.teach) / 100
			this.data.conf.determination_coef.teach = Number(this.in_data.conf.determination_coef.teach)
			this.data.conf.average_error.test = Number(this.in_data.conf.average_error.test) / 100
			this.data.conf.square_error.test = Number(this.in_data.conf.square_error.test) / 100
			this.data.conf.determination_coef.test = Number(this.in_data.conf.determination_coef.test)
			
			this.$emit("edit", { fields : fields })
		}
	}
}

</script>

